export default class ServiceCompaniesTicker {
  constructor() {
    this.tickerSpeedPxPerSec = 40;
    this.resizeDebounceMs = 200;
    this.lists = document.querySelectorAll(
      '.js-service_companies_ticker, .js-service_companies_ticker_reverse',
    );

    if (!this.lists.length) {
      return;
    }

    this.resizeTimer = null;
    this.onResize = this.onResize.bind(this);

    this.init();
  }

  async init() {
    this.lists.forEach((list) => this.duplicateItems(list));
    await this.waitForImages(this.lists);
    this.updateAllDurations();
    window.addEventListener('resize', this.onResize);
  }

  duplicateItems(list) {
    const items = [...list.children];

    items.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      list.appendChild(clone);
    });
  }

  waitForImages(lists) {
    const images = [...lists].flatMap((list) => [...list.querySelectorAll('img')]);

    if (!images.length) {
      return Promise.resolve();
    }

    return Promise.all(
      images.map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) {
              resolve();
              return;
            }

            img.addEventListener('load', resolve, { once: true });
            img.addEventListener('error', resolve, { once: true });
          }),
      ),
    );
  }

  updateAllDurations() {
    this.lists.forEach((list) => this.updateTickerMetrics(list));
  }

  updateTickerMetrics(list) {
    const distance = Math.round(list.scrollWidth / 2);
    const duration = distance / this.tickerSpeedPxPerSec;

    list.style.setProperty('--ticker-distance', `${distance}px`);
    list.style.setProperty('--ticker-duration', `${duration}s`);
  }

  onResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.updateAllDurations();
    }, this.resizeDebounceMs);
  }
}
